import { ChangeDetectorRef, Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { OtpService } from './services/checkout-services/-otp.service';
// src/navigator.d.ts


@Directive({
  selector: '[appWebOtp]'
})
export class WebOtpDirective {

  private ac = new AbortController();
  private timer: any  | null = null;
  constructor(private el: ElementRef,   private otpService:OtpService) { };

  @Input('timeout') timeout?: number;

  ngOnInit(): void {
    const options: CredentialRequestOptions = {
      otp: { transport: ['sms'] },
      signal: this.ac.signal
    }
    // console.log("initialize navigator ")
    navigator.credentials.get(options).then((otp: any) => {
      console.log("your otp is " + otp)
      this.el.nativeElement.value = otp.code;
      this.otpService.fillOtp(otp.code);
    }).catch(err => {
      console.log("navigator otp error " + err);
    });
    if (this.timeout) {
      this.timer = setTimeout(() => {
        this.ac.abort();
      }, this.timeout)
    }
    
  }
  ngOnDestroy(): void {
    this.ac.abort();
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

}
